import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import FormHelperText from '@mui/material/FormHelperText';

const CategoryItemForm = ({ state, errors, updateField, productions, item_category, category_type, prod_id, category_type_data }) => {

    const selectedProduction = productions?.find(
        (prod) => prod?.id === (state?.p_id || prod_id)
    );

    const filteredCategories = selectedProduction
        ? category_type?.filter((cat) =>
            cat.pc_pruduction?.p_descr.includes(selectedProduction?.p_descr || category_type_data?.p_descr)) : [];

    return (
        <Box p={4} display="flex" justifyContent="center">
            <Grid container spacing={1}>

                {/* Production Dropdown */}
                <Grid item xs={12} sm={12}>
                    <FormControl fullWidth size="small" error={!!errors.p_id} margin="normal">
                        <InputLabel id="prod-label">Παραγωγή</InputLabel>
                        <Select
                            labelId="prod-label"
                            id="prod-id"
                            label="Παραγωγή"
                            value={state?.p_id || prod_id || ""}
                            onChange={(e) => updateField("p_id", (e.target.value || prod_id))}
                            MenuProps={{
                                PaperProps: { elevation: 2 },
                            }}
                        >
                            {productions?.map((prod) => (
                                <MenuItem key={prod.id} value={prod.id}>
                                    {prod.p_descr}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.p_id && <FormHelperText>{errors.p_id}</FormHelperText>}
                    </FormControl>
                </Grid>

                {/* Category Dropdown */}
                <Grid item xs={12} sm={12}>
                    <FormControl
                        fullWidth
                        size="small"
                        error={!!errors.pc_type_id}
                        margin="normal"
                        disabled={!(state?.p_id || prod_id)}
                    >
                        <InputLabel id="category-label">Κατηγορία</InputLabel>
                        <Select
                            labelId="category-label"
                            id="category-id"
                            label="Κατηγορία"
                            value={state?.pc_type_id || category_type_data?.id || ""}
                            onChange={(e) => updateField("pc_type_id", e.target.value)}
                            MenuProps={{
                                PaperProps: { elevation: 2 },
                            }}
                        >
                            {filteredCategories?.map((cat) => (
                                <MenuItem key={cat.id} value={cat.id}>
                                    {cat.pct_descr}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.pc_type_id && <FormHelperText>{errors.pc_type_id}</FormHelperText>}
                    </FormControl>
                </Grid>

                {/* PCI Description */}
                <Grid item xs={12} sm={12}>
                    <TextField
                        size="small"
                        fullWidth
                        label="Περιγραφή"
                        value={state?.pci_descr || ""}
                        onChange={(e) => updateField("pci_descr", e.target.value)}
                        error={!!errors.pci_descr}
                        helperText={errors.pci_descr}
                    />
                </Grid>

                {/* PCI Amount */}
                <Grid item xs={12} sm={12}>
                    <TextField
                        size="small"
                        margin="normal"
                        fullWidth
                        label="Προϋπολογισμός"
                        value={state?.pci_amount ?? ""}
                        onChange={(e) => {
                            const value = e.target.value === "" ? "" : parseFloat(e.target.value);
                            updateField("pci_amount", isNaN(value) ? "" : value);
                        }}
                        helperText={errors.pci_amount || ""}
                        error={!!errors.pci_amount}
                        type="number"
                        inputProps={{ step: "0.01", min: "0.00" }}
                    />
                </Grid>

                {/* Category Payment Type Dropdown */}
                <Grid item xs={12} sm={12}>
                    <FormControl
                        fullWidth
                        size="small"
                        error={!!errors.pci_type}
                        margin="normal"
                    >
                        <InputLabel id="payment-type-label">Τρόπος Τιμολόγησης</InputLabel>
                        <Select
                            size="small"
                            labelId="payment-type-label"
                            id="payment-type-id"
                            label="Τρόπος Τιμολόγησης"
                            value={state?.pci_type || ""}
                            onChange={(e) => updateField("pci_type", e.target.value)}
                            MenuProps={{
                                PaperProps: { elevation: 2 },
                            }}
                        >
                            {item_category?.map((cat) => (
                                <MenuItem key={cat.id} value={cat.id}>
                                    {cat.pcit_descr}
                                </MenuItem>
                            ))}
                        </Select>
                        {errors.pci_type && <FormHelperText>{errors.pci_type}</FormHelperText>}
                    </FormControl>
                </Grid>

                {/* PCI AA */}
                <Grid item xs={12} sm={12}>
                    <TextField
                        size="small"
                        fullWidth
                        label="A/A"
                        value={state?.pci_aa || ""}
                        onChange={(e) => updateField("pci_aa", Number(e.target.value))}
                        error={!!errors.pci_aa}
                        helperText={errors.pci_aa}
                    />
                </Grid>

                {/* PCI Notes */}
                <Grid item xs={12} sm={12}>
                    <TextField
                        size="small"
                        fullWidth
                        label="Παρατηρήσεις"
                        value={state?.pci_notes || ""}
                        onChange={(e) => updateField("pci_notes", e.target.value)}
                        error={!!errors.pci_notes}
                        helperText={errors.pci_notes}
                        multiline
                        minRows={4}
                        maxRows={6}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default CategoryItemForm;
